import React from 'react';

import Header from 'presentation/components/Header.jsx';
import styles from 'presentation/components/styles/ChatClosed.css';

const ChatClosed = ({ throttledMessage }) => {
  let message =
    throttledMessage ||
    'We want to chat with you, but we are experiencing higher chat volumes than usual. Please visit our contact page for other ways to reach out to us.';
  return (
    <div className={styles.chatClosed} data-aid="gladlyChatClosedPane">
      <Header title="Whoops, sorry we missed you!" />
      <div className={styles.chatClosed_body}>{message}</div>
    </div>
  );
};

export default ChatClosed;
